export default __webpack_public_path__ + "static/media/NoBuy.21e05ef5.svg";